import { render, staticRenderFns } from "./w-card.vue?vue&type=template&id=601d13d4&"
import script from "./w-card.vue?vue&type=script&lang=ts&"
export * from "./w-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports